import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/logo/iknowa-logo-v4.svg'
import _imports_1 from '../../../assets/images/iknowa_logo.svg'
import _imports_2 from '../../../assets/images/speedometer.png'


const _withScopeId = n => (_pushScopeId("data-v-9eab1e4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-setting-up" }
const _hoisted_2 = { class: "dashboard-setting-up__row" }
const _hoisted_3 = { class: "dashboard-setting-up__left" }
const _hoisted_4 = { class: "custom-card" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-setting__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: 160,
    "aspect-ratio": "16/9",
    cover: "",
    src: _imports_0
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "progress-title" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "common-title" }, " Your iknowa Passport & Know Your Property (KYP) Is Complete 🎉 "),
    /*#__PURE__*/_createElementVNode("p", { class: "body-text" }, "Here’s what it gives you;")
  ])
], -1))
const _hoisted_7 = { class: "modal_card_list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Value One ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Value Two ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Value Three ", -1))
const _hoisted_11 = { class: "bottom-btn desktop__wrapper" }
const _hoisted_12 = { class: "dashboard-setting-up__right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-logo-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-logo-header__wrap" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "site-logo-img",
      src: _imports_1,
      width: "106",
      height: "24"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "under-line" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "custom__tags" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-logo-header__tags" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "tag-item" }, [
        /*#__PURE__*/_createElementVNode("span", null, " KNOW YOUR PROPERTY"),
        /*#__PURE__*/_createTextVNode(" Preview")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "onbording-wrap__card-tag" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "tag-item__points" }, [
        /*#__PURE__*/_createElementVNode("span", null, "1,414"),
        /*#__PURE__*/_createTextVNode(" Verified Data Points ")
      ])
    ])
  ])
], -1))
const _hoisted_14 = { class: "profile-wrap common-profile-view" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "dashboard-verify-profile__name" }, " 9 Cornwallis Avenue ", -1))
const _hoisted_17 = { class: "dashboard-verify-profile__address" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Folkestone, Kent, UK", -1))
const _hoisted_19 = { class: "location__wrapper" }
const _hoisted_20 = {
  key: 0,
  class: "card-part"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "speedmeter__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_22 = { class: "speedmeter__text" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Here we can have a brief explainer as to the score and the major factors that contribute to it shown below. ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-property__list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dashboard-property__list_items" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "left_list__item" }, "Energy Efficiency Rating"),
    /*#__PURE__*/_createElementVNode("p", { class: "right_list__item" }, "75")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dashboard-property__list_items" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "left_list__item" }, "KYP Highlight"),
    /*#__PURE__*/_createElementVNode("p", { class: "right_list__item" }, "Answer")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dashboard-property__list_items" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "left_list__item" }, "Estimated Property Value"),
    /*#__PURE__*/_createElementVNode("p", { class: "right_list__item" }, "£320,000")
  ])
], -1))
const _hoisted_25 = { class: "bottom-btn mobile__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_commonDialog = _resolveComponent("commonDialog")!

  return (_openBlock(), _createBlock(_component_commonDialog, {
    HeaderTittle: "Know Your Property (KYP) Preview",
    isShowBackButton: false,
    class: "carousel__dialog custom__modal__box",
    "max-width": "100%"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_8
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_9
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_10
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  onClick: $setup.onClickComplete,
                  loading: $setup.loadingContinue
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Explore 🚀 ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_card, { class: "custom-card" }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                        _createElementVNode("span", null, _toDisplayString($setup.propertyListData?.postcode), 1)
                      ])
                    ])
                  ])
                ]),
                (!$setup.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_v_chip, { variant: "flat" }, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString($setup.propertyListData?.days_on_market), 1),
                            _createTextVNode(" Poor ")
                          ]),
                          _: 1
                        }),
                        _hoisted_23
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_CommonLoader, {
                      key: 1,
                      loading: $setup.loading
                    }, null, 8, ["loading"])),
                _hoisted_24
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_v_btn, {
                class: "button button-orange",
                onClick: $setup.onClickComplete,
                loading: $setup.loadingContinue
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Explore 🚀 ")
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}